__turbopack_context__.v({
  "originals": "hero-profit-proof-module__oabYPG__originals",
  "receipts": "hero-profit-proof-module__oabYPG__receipts",
  "textLink": "hero-profit-proof-module__oabYPG__textLink",
  "visual": "hero-profit-proof-module__oabYPG__visual",
});
